import styles from "./AddAccounts.module.scss"
import down from "../../../../assets/images/downArrow.svg"
import delete_red from "../../../../assets/images/delete_red.svg"
import error_mark from "../../../../assets/images/error_mark.svg"
import InputTag from "../../../../components/Input/InputTag"
import { gstinError } from "../../accountFields"
import validationError from "../../../../enums/validationError"
import { useSelector } from "react-redux"
import { getAllStates } from "../../../Common/commonSlice"
import FileUploader from "../../../Projects/features/RaiseTicketForm/common/FileUploader/FileUploader"
import MuiAutoComplete from "../../../../components/MuiAutocomplete"
import { Box } from "@mui/material"
import CountrySelectField from "../../../../components/MuiCountrySelect"

type Props = {
    addStates: any
    addfunctions: any
}

const ShippingAddress = (props: Props) => {
    const { addStates, addfunctions } = props
    const { formValues, showLocationDetails } = addStates
    const {
        removeFormFields,
        addFormFields,
        handleChanges,
        toggleDetails,
        handleTogglePrimary,
        handleFileChanges,
        handleCountryChanges,
    } = addfunctions

    const allPrimaryFalse = formValues
        ?.filter((item: any) => item.is_active === 1)
        ?.every((item: any) => item.is_primary === 0)

    return (
        <div style={{ margin: "5px 0px 15px 0px" }}>
            {formValues
                ?.filter((item: any) => item.is_active === 1)
                .map((element: any, index: number) => {
                    // Format, and the state code against the selected state (Indian addresses).
                    const gstinErrorText = gstinError(
                        element?.gstin,
                        element?.state_id?.title,
                        element?.country?.id === 101
                    )
                    return (
                        <div
                            className={`${styles.editProfile_modal__form__flex} ${styles.address_container}`}
                            style={{
                                borderBottom:
                                    index !== formValues.filter((item: any) => item.is_active === 1).length - 1
                                        ? "1px solid #EAEAEA"
                                        : "",
                            }}
                            key={index}>
                            <div className={styles.section3} style={{ padding: "6px" }}>
                                <Box
                                    className={styles.title}
                                    sx={{
                                        cursor: "pointer",
                                    }}
                                    onClick={() => toggleDetails(index)}>
                                    <div className={styles.title}>
                                        BILLING ADDRESS {index + 1}
                                        {formValues?.filter((item: any) => item.is_active === 1)?.length > 1 ? (
                                            <div
                                                className={styles.account_remove}
                                                style={{ padding: "0px 16px", cursor: "pointer" }}>
                                                <img
                                                    src={delete_red}
                                                    alt="delete_red"
                                                    onClick={() => removeFormFields(index)}
                                                />
                                            </div>
                                        ) : null}
                                    </div>
                                    <span>
                                        <img
                                            src={down}
                                            alt="down"
                                            // onClick={() => toggleDetails(index)}
                                            style={{
                                                transform: showLocationDetails[index] ? "" : "rotate(180deg)",
                                            }}
                                        />
                                    </span>
                                </Box>
                                {showLocationDetails[index] && (
                                    <>
                                        <div className={styles.editProfile_modal__form__flex}>
                                            {formValues.filter((item: any) => item.is_active === 1)?.length > 1 ? (
                                                <div className="flex">
                                                    <input
                                                        type="checkbox"
                                                        checked={element?.is_primary === 1}
                                                        onChange={() => handleTogglePrimary(index)}
                                                        style={{ cursor: "pointer" }}
                                                    />
                                                    <span
                                                        className={styles.editProfile_modal__form__flex__label}
                                                        style={{ margin: "0px 10px" }}>
                                                        Set as Primary
                                                    </span>
                                                    {allPrimaryFalse &&
                                                        element?.is_primary !== 1 &&
                                                        addStates?.toggleError && (
                                                            <img
                                                                src={error_mark}
                                                                alt="error"
                                                                title="One checkbox must be checked to set a single billing address as Primary"
                                                            />
                                                        )}
                                                </div>
                                            ) : (
                                                <div></div>
                                            )}
                                            <div></div>
                                            <div>
                                                <label className={styles.editProfile_modal__form__flex__label}>
                                                    Country*
                                                </label>
                                                <CountrySelectField
                                                    value={element.country}
                                                    onChange={e => handleCountryChanges(index, e)}
                                                    required={true}
                                                    showError={!element.country?.id && addStates.toggleError}
                                                />
                                            </div>
                                            <div></div>
                                            <div>
                                                <label className={styles.editProfile_modal__form__flex__label}>
                                                    Billing Address*
                                                </label>
                                                <InputTag
                                                    required
                                                    name="address"
                                                    placeholder="Enter Billing Address"
                                                    error={!element?.address}
                                                    showError={addStates.toggleError}
                                                    value={element?.address || ""}
                                                    onChange={e => handleChanges(index, e)}
                                                />
                                            </div>
                                            <div>
                                                <label className={styles.editProfile_modal__form__flex__label}>
                                                    Pincode{element?.country?.id === 101 ? "*" : ""}
                                                </label>
                                                <InputTag
                                                    name="pincode"
                                                    placeholder="Enter Pincode"
                                                    value={element?.pincode || ""}
                                                    maxLength={6}
                                                    onChange={e => handleChanges(index, e)}
                                                    required={element?.country?.id === 101}
                                                    error={
                                                        element?.country?.id === 101 &&
                                                        !(element?.pincode?.toString()?.length === 6)
                                                    }
                                                    errorText={validationError?.PINCODE}
                                                    showError={element?.country?.id === 101 && addStates.toggleError}
                                                />
                                            </div>
                                            <div style={{ paddingRight: 10 }}>
                                                <div className={styles.editProfile_modal__form__flex__label}>
                                                    Select State*
                                                </div>
                                                <MuiAutoComplete
                                                    options={element?.shippingStates?.map((data: any) => {
                                                        return { id: data?.id, title: data?.name }
                                                    })}
                                                    value={element?.state_id}
                                                    onChange={(e: any) =>
                                                        addfunctions.changeshippingStateHandle(index, e)
                                                    }
                                                    containerHeight="34px"
                                                    placeholder="Select State"
                                                    disabled={!element?.country?.id}
                                                    error={!element?.state_id?.id && addStates.toggleError}
                                                />
                                            </div>
                                            <div>
                                                <div className={styles.editProfile_modal__form__flex__label}>
                                                    Select City*
                                                </div>
                                                <MuiAutoComplete
                                                    options={element?.shippingCities?.map((data: any) => {
                                                        return { id: data?.id, title: data?.name }
                                                    })}
                                                    value={element?.city_id}
                                                    onChange={(e: any) =>
                                                        addfunctions.changeshippingCityHandle(index, e)
                                                    }
                                                    containerHeight="34px"
                                                    placeholder="Select City"
                                                    disabled={!element?.state_id?.id}
                                                    error={!element?.city_id?.id && addStates.toggleError}
                                                />
                                            </div>
                                            <div>
                                                <div className={styles.editProfile_modal__form__flex__label}>
                                                    GSTIN Number
                                                </div>
                                                <InputTag
                                                    name="gstin"
                                                    value={element?.gstin}
                                                    error={!!gstinErrorText}
                                                    maxCharacter={15}
                                                    // Shown once all 15 characters are in, or on submit.
                                                    showError={
                                                        element?.gstin?.length === 15 ||
                                                        (element?.gstin?.length > 0 && addStates.toggleError)
                                                    }
                                                    onChange={(e: any) => addfunctions.handleChanges(index, e)}
                                                    placeholder="Enter GSTIN Number"
                                                    errorText={gstinErrorText ?? undefined}
                                                />
                                            </div>
                                            <div className={`${styles.editProfile_modal__form__flex__description}`}>
                                                <div className={`${styles.editProfile_modal__form__flex__label}`}>
                                                    GST Certificate
                                                </div>
                                                <div className={`input_file_type`} style={{ border: "none" }}>
                                                    <label
                                                        className={`files_label ${
                                                            element?.gst_certificate_url?.name ? "uploaded" : ""
                                                        }`}>
                                                        Upload File
                                                    </label>
                                                    <FileUploader
                                                        name="gst_certificate_url"
                                                        onChange={files =>
                                                            handleFileChanges(index, files, "gst_certificate_url")
                                                        }
                                                        title="Upload File"
                                                    />
                                                </div>
                                                {element?.gst_certificate_url?.length === 0 ||
                                                !element?.gst_certificate_url ? (
                                                    <div
                                                        className={`${styles.editProfile_modal__form__flex__description__text} flex-between`}
                                                        style={{ marginTop: 3, color: "red" }}>
                                                        <div>10MB Max</div> <div>File Type: JPG, PDF, PNG</div>
                                                    </div>
                                                ) : (
                                                    <span
                                                        className={`${styles.editProfile_modal__form__flex__description__text} file_uploaded`}>
                                                        1 files uploaded
                                                    </span>
                                                )}
                                            </div>
                                        </div>
                                    </>
                                )}
                            </div>
                        </div>
                    )
                })}
        </div>
    )
}

export default ShippingAddress
